export default __webpack_public_path__ + "static/media/crystal.7d002256.mp3";